import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { DocumentLibraryItem } from "@rumble-it/common-lib/types/models/DocumentLibraryItem.interface";
import { Button } from "@rumbledirect/ui";
import { Popconfirm, Space, TableColumnsType } from "antd";

interface DocumentLibraryItemWithActions extends DocumentLibraryItem {
  onDelete?: (id: string) => void;
}

export const documentLibraryItemColumns = (
  onDelete: (id: string) => void,
  onEditCompany: (document: DocumentLibraryItem) => void,
): TableColumnsType<DocumentLibraryItemWithActions> => [
  {
    title: "Bestandsnaam",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Status",
    dataIndex: ["processingStatus", "label"],
    key: "processingStatus",
  },
  {
    title: "Bedrijf",
    dataIndex: "companies",
    key: "companies",
    render: (companies: DocumentLibraryItem["companies"]) =>
      companies && companies.length > 0
        ? companies.map((company) => company.name).join(", ")
        : "-",
  },
  {
    title: "Toegevoegd",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (date: string) => new Date(date).toLocaleString("nl-NL"),
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: unknown, record: DocumentLibraryItemWithActions) => (
      <Space>
        <Button
          icon={<EditOutlined />}
          onClick={() => onEditCompany(record)}
          title="Bedrijf bewerken"
        />
        <Popconfirm
          title="Document verwijderen"
          description="Weet je zeker dat je dit document wilt verwijderen?"
          onConfirm={() => onDelete(record.id)}
          okText="Ja"
          cancelText="Nee"
        >
          <Button danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    ),
  },
];
